<div class="audit-page">
    <h1 class="title">Individual Audits</h1>




    <p class="average-score" style="color: #8b8989;
    padding-bottom: 1em;">Use this page to view the results of individual audits. Click scores to view notes.
    Audit emails go to the inspectors and their supervisors (up to the regional manager level).</p>
  
    <p class="average-score" style="margin-bottom: 0px;font-weight: 600;color: #6d6d6d;">Total Audits: {{ filteredAudits.length }}</p>
    <p class="average-score" style="font-weight: 600;color: #6d6d6d;">Average Score: {{ getAverageScore() }}</p>

    <div class="searchDiv" style="display: flex;
        align-items: center;
        padding-bottom: 2em;">
    <!-- Search Box -->
      <div class="search-box" style="margin: 0;width: 60%;padding-right: 1em; position:relative;">
        <input
          type="text"
          id="searchBox"
          class="actualSearchBox"
          placeholder="Search audits..."
          [(ngModel)]="searchTerm"
          (input)="processFilters()" 
          style="padding-right: 5em;"
        />
        <button class="resetbutton" (click)="clearAll()"> Clear all</button>
      </div>

      <div style="display: flex;" *ngIf="isTManager || isDirector">

          <div style="align-content: center;" >
            <p style="margin: 0;color: #bababa;font-weight: 600;">Search on: </p>
          </div>
          <div>
              <select id='searchStyle' [(ngModel)]='searchMode' style="margin-left: 1em;border: 0;padding: 1em;color: #8bc34a;" 
              (change)="changeSearchType($event)" class="searchType">
                  <option value="0" default>All Fields</option>
                  <option value="1">Region Only</option>
                  <option value="2">Rater</option>
              </select>
          </div>

      </div>

    </div>

    <div id = "selectDiv" *ngIf="this.searchMode == 1">
      <select [(ngModel)]="selectedRegion" multiple (change)="onRegionChange(); processFilters();" style="width: 5em;
    color: #424242;
    background: #f0f8ff00;
    height: 5em;
    padding: 0.5em;
    border: 0;
    float: right;
    scrollbar-color: black white;">
        <option *ngFor="let region of regions" [value]="region.region">
          {{ region.region }}
        </option>
      </select>
    </div>
    <div id="filterDiv" class="filterDiv" *ngIf="isTManager || isDirector">

  <label>
    <input type="radio"
          name="filterOptions"
          [value]="FilterMode.All"
          [(ngModel)]="filterMode"
          (ngModelChange)="onRadioChange($event)">
    All
  </label>

  <label>
    <input type="radio"
          name="filterOptions"
          [value]="FilterMode.QI"
          [(ngModel)]="filterMode"
          (ngModelChange)="onRadioChange($event)">
    QIs Only
  </label>

  <label *ngIf="!isQISpecialist">
    <input type="radio"
          name="filterOptions"
          [value]="FilterMode.Energy"
          [(ngModel)]="filterMode"
          (ngModelChange)="onRadioChange($event)">
    Energy Only
  </label>

    </div>

    <div id="tmanagersearch" style="display: flex;padding-bottom:2em;align-items: center;" class="dateFilterDiv">

      <div style="padding-right: 1em;" class="dateBoxes"><label style="margin: 0; padding-right: 1em;color: #6d6d6d;">From</label>
          <input type="date" class="dateInputs" [(ngModel)]="fromDate" (change)="disableToDates()" style="color: #bababa;border: 0;height: 2em;padding: 1em;">
      </div>
      <div style="padding-right: 1em;" class="dateBoxes">
        <label style="margin: 0;padding-right: 1em;color: #6d6d6d;">To</label>
        <input type="date" id="toDate" [attr.min]="fromDate" [disabled]="!fromDate" class="dateInputs" [(ngModel)]="toDate" style="color: #bababa;border: 0;height: 2em;padding: 1em;">
      </div>
      <div>
        <button style="margin-left: 1em;
        border: 0;
        padding: 0.5em;
        width: 7em;
        background: #8dc73f;
        color: white;" (click)="turnOnDateSearch()">Filter Date</button>
      </div>

      <div>
        <button style="margin-left: 1em;
        border: 0;
        padding: 0.5em;
        width: 7em;
        background: white;
        color: #424242;" *ngIf="dateSearchOn" (click)="clearDateRange()">Unfilter Date</button>
      </div>

    </div>
  
    <!-- Audits List -->
    <div *ngFor="let audit of filteredAudits"
       class="audit-card">

      <div class="card-content">
        <!-- Main Info -->
        <div class="main-info">
          <!-- Subdivision and Lot -->
          <div class="subdivision-info">
            <h2 style="margin-bottom: 0px;">{{ audit.subdivision_name }} <span>{{ audit.lot }}</span> </h2>
            <p class="street-address">{{ audit.street_address }}</p>

          </div>
          <!-- Employee Info -->
          <p style="color: #afafaf;margin-bottom:0;">{{audit.schedule_date.substring(0,10) }} <span style="color: #afafaf;">{{ audit.employee_name }} ({{audit.region}})</span></p>
        </div>
  
        <!-- Score Section -->
        <div class="score-section" (click)="toggleNotes(audit)" title="Click to view notes">
          <p class="score-label">Score</p>
          <p class="score-value">{{ audit.score }}</p>
        </div>
      </div>
  
      <!-- Collapsible Audit Notes -->
      <div *ngIf="audit.showNotes" class="notes-content">
        <p style="margin-bottom: 0px; font-weight: 200;">Auditor: {{audit.auditorname}}</p>
        <p style="font-weight: 200;">Stage Done: {{audit.constage}}</p>
        <p style="    white-space: break-spaces;
        color: #424242;
        font-weight: 200;
        margin-bottom: 0;">Notes: </p>
        <p style="white-space: break-spaces; padding: 1em; color: #424242;">{{ audit.audnotes }}</p>
      </div>

    </div>

  </div>
  